import {ErrorMessageProps, ErrorsMessage, ErrorsType} from './ErrorsType';
import React, {useState} from 'react';
import {HttpError} from '../../../../api/client';
import {ApiError} from './ErrorBoundary';
import {MessageDialog} from '../MessageDialog/MessageDialog';
import {useStyleSpanUnderline} from './InternalServerErrorMessage';

function GetBadRequestMessage(error: Error):{message: string, isInformasjon: boolean} {
  try{
    const apiError = (error as HttpError).data as ApiError;
    if ((apiError as any)?.extraInfoList?.length) {
      const message = (apiError as any)?.extraInfoList.join('\n');
      return {message, isInformasjon: true};
    }
    if ((apiError as any)?.errors) {
      const propertyNames = Object.getOwnPropertyNames(((apiError as any)?.errors));
      const message = propertyNames.reduce((previousValue: string, currentValue: string) =>{
        if(typeof (apiError as any).errors[currentValue] === 'string')
          return previousValue + '\n' + (apiError as any).errors[currentValue];
        if(Array.isArray((apiError as any).errors[currentValue]))
        {
          const errors = (apiError as any).errors[currentValue] as string[];
          return previousValue + '\n' + errors?.join();
        }
        return previousValue;
      }, apiError.message ?? '');
      return {message, isInformasjon: false};
    }
    return {message:error.message, isInformasjon: false};
  }catch(ex: any){
    return  {
      message: ex.message, isInformasjon: false
    };
  }
}

export const BadRequestMessage: React.FC<ErrorMessageProps> = ({open, onClose, error}) => {
  const {underlineHover} = useStyleSpanUnderline();
  const {message, isInformasjon} = GetBadRequestMessage(error as any);
  const [showDetail, setShowDetail] = useState(false);
  return (
    <MessageDialog title={isInformasjon ? 'Informasjon' : 'En feil har oppstått'} width={isInformasjon ? undefined : 700} height={isInformasjon ? undefined : 300} open={open} onClose={onClose}>
      <div>
        <span hidden={isInformasjon}> {ErrorsMessage[ErrorsType.BadRequest]}</span><span onClick={() => setShowDetail(prev => !prev)}  hidden={isInformasjon || !message?.length} className={underlineHover}> Les mer.</span>
        {(showDetail || isInformasjon) &&
          (<p style={{whiteSpace: 'pre-wrap', display: 'block',width: 'max-content'}}>
            {message}
          </p>)
        }
      </div>
    </MessageDialog>
  );
};
